/* 0.47.51 - The last rows of a small library, kept in the browser
 * (localStorage), so a page opened again draws its library-backed
 * dropdowns at once with the right shape: a short list as radio
 * buttons straight away, rather than a dropdown that turns into radio
 * buttons when the rows arrive a moment later.
 *
 * The page still fetches the rows every time and replaces the copy.
 * Only small libraries are kept (they are the ones shown as radio
 * buttons or checkboxes), and any storage failure (private mode, a
 * full quota) just means no copy. */

const PREFIX = 'gt18.libRows.';
const MAX_ROWS = 100;
const MAX_CHARS = 100000;

const keyOf = (lib, lang) => `${PREFIX}${lib}|${lang || ''}`;

export function readLibraryRows(lib, lang) {
  try {
    const raw = window.localStorage.getItem(keyOf(lib, lang));
    if (!raw) return null;
    const v = JSON.parse(raw);
    return v && Array.isArray(v.rows) ? v : null;
  } catch {
    return null;
  }
}

export function writeLibraryRows(lib, lang, data) {
  try {
    if (!data || !Array.isArray(data.rows)) return;
    if (data.rows.length === 0 || data.rows.length > MAX_ROWS) {
      window.localStorage.removeItem(keyOf(lib, lang));
      return;
    }
    const s = JSON.stringify({ rows: data.rows, pk: data.pk ?? null, column_types: data.column_types || null });
    if (s.length > MAX_CHARS) { window.localStorage.removeItem(keyOf(lib, lang)); return; }
    window.localStorage.setItem(keyOf(lib, lang), s);
  } catch { /* no copy */ }
}
